(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["ducksuite"]) return;
  try {
    
var ducksuite = new DucksuiteWidget(10, "slideshow", "ducksuite_container1",document.location.hash); ducksuite.setupWidget(true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ducksuitep-section"]) return;
  try {
    
(function (d, s, url) {
    (a = d.createElement(s)), (m = d.getElementsByTagName(s)[0]); 
    a.src = url;
    a.asyn = 1;
    m.parentNode.insertBefore(a, m);
    
})(document, "script", "//san.worksonline.dk/v2/ducksuite_widget.js");
 window.onload = function(){ new DucksuiteWidget(7, "collage", "ducksuite_instagram"); }; 

  } catch(e) { console.error(e); }
})();

})();
